import React from 'react';
import Views from '.';
import NumberPicker from './number-picker';

const NumberEntryView = ({title, left, right, ...props}) => {
  return (
    <Views title={title} left={left} right={right}>
      <NumberPicker {...props} />
    </Views>
  );
};

export default NumberEntryView;
